/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

import CheckWebpFeature from "./src/components/common/ggfx-client/module/webp-checker";
CheckWebpFeature();

export { wrapRootElement } from "./src/apollo/wrap-root-element";

// --- Delayed GTM: loads on first user interaction or after 5s, keeping main thread free during LCP/TBT window ---
const GTM_ID = 'GTM-NJRBFKN'
let gtmLoaded = false

const initGTM = () => {
  if (gtmLoaded) return
  gtmLoaded = true
  ;(function (w, d, s, l, i) {
    w[l] = w[l] || []
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
    var f = d.getElementsByTagName(s)[0]
    var j = d.createElement(s)
    var dl = l !== 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    f.parentNode.insertBefore(j, f)
  })(window, document, 'script', 'dataLayer', GTM_ID)
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  // console.log('new pathname', location.pathname)
  // console.log('old pathname', prevLocation ? prevLocation.pathname : null)
  if (prevLocation && !prevLocation.pathname.match(/new-homes-for-sale/)) {
    if (window)
      window.scroll({
        top: -100,
        behavior: 'smooth'
      });
  }

  // When navigating to a page containing the CookieYes auto-policy div via Gatsby's
  // client-side router, CookieYes has already initialised on the previous page and won't
  // re-scan. Wait a tick for React to finish rendering the new page, then dispatch the
  // event CookieYes uses to re-render its cookie policy table.
  if (prevLocation && document.getElementById('cky-auto-cookie-policy')) {
    setTimeout(() => {
      const el = document.getElementById('cky-auto-cookie-policy')
      if (el && el.children.length === 0 && window.CookieYes) {
        window.dispatchEvent(new CustomEvent('cky-consent-ready'))
      }
    }, 300)
  }
  
}


export const onInitialClientRender = () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ platform: 'gatsby' })

  window.addEventListener('popstate', () =>
    window.location.href = window.location.href
  )

   // Load GTM at window.onload (after all resources) rather than waiting for user interaction.
  // This ensures CMPs like CookieYes load before DOMContentLoaded has long since fired,
  // and before the user has interacted, so their auto-policy injection runs correctly.
  if (document.readyState === 'complete') {
    initGTM()
  } else {
    window.addEventListener('load', initGTM, { once: true })
  }
}

export const shouldUpdateScroll = ({
    routerProps: { location },
    getSavedScrollPosition
}) => {
  
    // Avoid to scroll to top when next page trigger click
    // But this feature should condiser with details page back scroll too
    if (location.pathname.match(/new-homes-for-sale/)) {
      return false;
    }
  
    return true;
};